import React, { Component } from "react";
import { logoutUser } from "../modules/actions";
import { getUserData } from "../modules/reducers";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { compose } from "redux";
import Breadcrumb from "./Breadcrumb";

class Topbar extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    logoutUser = () => {
        this.props.logout();
        this.props.history.push('/');
    }
    
    toggleSidebar = () => {
        window.dispatchEvent(new Event('toggle-sidebar'));
    };
    
    render() {
        return (
            <>
                {/* Topbar Start */}
                <div className="navbar-custom">
                    <div className="d-flex align-items-center gap-3">
                        <button 
                            className="btn btn-link p-0 text-dark" 
                            onClick={this.toggleSidebar}
                            style={{ fontSize: '1.5rem', textDecoration: 'none' }}
                        >
                            <i className="mdi mdi-menu"></i>
                        </button>
                        <div>
                            <h4 className="page-title mb-0">{this.props.act}</h4>
                            {this.props.breadcrumbItems && (
                                <Breadcrumb items={this.props.breadcrumbItems} />
                            )}
                        </div>
                    </div>
                    {/* <div className="ml-auto">
                        <a href="javascript:void(0);" onClick={this.logoutUser} className="dropdown-item notify-item">
                            <i className="mdi mdi-logout me-1" />
                            <span>Logout</span>
                        </a>
                    </div> */}
                </div>
                {/* end Topbar */}

            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: getUserData(state),
    }
}

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(logoutUser()),
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Topbar);